import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const ArrowRight: React.FC<IIconProps> = ({
  size = IconSizes.md,
  color = 'black',
  UNSAFE_className: _UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4193 7.28476C11.0396 7.66443 11.0396 8.28001 11.4193 8.65969L18.5096 15.75L11.4193 22.8403C11.0396 23.22 11.0396 23.8356 11.4193 24.2152C11.799 24.5949 12.4145 24.5949 12.7942 24.2152L20.572 16.4375C20.7543 16.2551 20.8568 16.0078 20.8568 15.75C20.8568 15.4922 20.7543 15.2449 20.572 15.0625L12.7942 7.28476C12.4145 6.90508 11.799 6.90508 11.4193 7.28476Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowRight;
